import * as jQuery from 'jquery';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { addResizeListener, removeResizeListener } from 'detect-element-resize';
import 'rxjs/add/operator/debounceTime';

interface Params {
  nextBtn: JQuery;
  prevBtn: JQuery;
  scrollArea: JQuery;
  scrollItems: JQuery;
  pixelsPerSecond: number
};

interface ScrollPos {
  left: number;
  right: number;
}

export class Carousel {

  private params: Params;
  private updateScrollButtonsEvent: BehaviorSubject<null> = new BehaviorSubject(null);

  constructor(private elem: JQuery, params: Partial<Params>) {
    
    this.params = jQuery.extend(
      {
        nextBtn: this.elem.find('[data-carousel-next]').first(),
        prevBtn: this.elem.find('[data-carousel-prev]').first(),
        scrollArea: this.elem.find('[data-carousel-scroll-area]').first(),
        scrollItems: this.elem.find('[data-carousel-scroll-area] > *'),
        pixelsPerSecond: 400
      }, 
      params
    );

    this.params.nextBtn.on('click', () => this.next());

    this.params.prevBtn.on('click', () => this.prev());

    // trigger update on scroll
    jQuery(this.params.scrollArea).on('scroll', 
      () => this.updateScrollButtonsEvent.next(null)
    );

    // trigger update on resize
    addResizeListener(this.elem[0], () => this.updateScrollButtonsEvent.next(null));

    this.updateScrollButtonsEvent.debounceTime(500).subscribe(
      () => this.updateScrollButtons()
    );
    
    this.updateScrollButtons();
  }

  getScrollPos() {
    return {
      left: this.params.scrollArea.scrollLeft(), 
      right: this.getScrollAreaScrollRight()
    } as ScrollPos;
  }

  getScrollAreaScrollRight() {
    
    return -1 * (this.params.scrollArea.width() - (this.params.scrollArea[0].scrollWidth - this.params.scrollArea.scrollLeft()));

  }

  updateScrollButtons() {
    
    const scrollPos = this.getScrollPos();

    if(scrollPos.left === 0) {
      
      this.params.prevBtn.css('visibility', 'hidden');

    } else {
    
      this.params.prevBtn.css('visibility', 'visible');

    }

    if(scrollPos.right === 0) {

      this.params.nextBtn.css('visibility', 'hidden');

    } else {

      this.params.nextBtn.css('visibility', 'visible');

    }

  }

  getPixelsToRightEdge(elem: JQuery) {

    return elem.position().left + elem.outerWidth()

  }

  next() {
    
    const scrollAreaXOffset = this.params.scrollArea.offset().left;

    const scrollAreaXPixelsScrolled = this.getScrollPos().left;

    const breaks: number[] = new Array();

    let scrollTo = 0;

    this.params.scrollItems.each(
      (index, item) => {

        breaks.push(
          jQuery(item).offset().left - scrollAreaXOffset + scrollAreaXPixelsScrolled + jQuery(item).outerWidth(true)
        );        

      }
    );

    const sorted_breaks = breaks.sort((a,b) => (a-b) );

    for (let stoppoint of sorted_breaks) {
      
      if(stoppoint > scrollAreaXPixelsScrolled) {

        scrollTo = Math.ceil(stoppoint);
        
        break;

      }

    }

    this.scrollTo(scrollTo);
    
  }

  prev() {

    const scrollAreaXOffset = this.params.scrollArea.offset().left;

    const scrollAreaXPixelsScrolled = this.getScrollPos().left;

    const breaks: number[] = new Array();

    let scrollTo = 0;

    this.params.scrollItems.each(
      (index, item) => {

        breaks.push(
          jQuery(item).offset().left - scrollAreaXOffset + scrollAreaXPixelsScrolled
        );        

      }
    );

    const sorted_breaks = breaks.sort((a,b) => (b-a) );

    for (let stoppoint of sorted_breaks) {
      
      if(stoppoint < scrollAreaXPixelsScrolled) {

        scrollTo = Math.floor(stoppoint);
        
        break;

      }

    }

    this.scrollTo(scrollTo);

  }

  scrollTo(scrollTo: number) {
    
    const time = Math.abs(this.getScrollPos().left - scrollTo) / this.params.pixelsPerSecond * 1000;

    this.params.scrollArea.animate({
      scrollLeft: scrollTo
    }, time, 'swing');

  }

}


// WEBPACK FOOTER //
// ./resources/src/components/carousel/carousel.tsx